// Division options keyed by level. College → D1/D2/D3/NAIA/Club/NCLA.
// HS → Varsity/JV/Middle School (NEVER "Varsity" for college).
// MS → Middle School only.
export const HS_DIVISIONS = ["HS Varsity", "JV", "Freshman", "Middle School"];
export const COLLEGE_DIVISIONS = ["D1", "D2", "D3", "NAIA", "NJCAA", "MCLA D1", "MCLA D2", "WCLA", "NCLA", "Club"];
export const MS_DIVISIONS = ["Middle School"];

export function divisionsForLevel(level) {
  switch ((level || "").toLowerCase()) {
    case "hs":
    case "high school":
      return HS_DIVISIONS;
    case "ms":
    case "middle school":
      return MS_DIVISIONS;
    case "college":
    default:
      return COLLEGE_DIVISIONS;
  }
}

// Union for filters / criteria where level isn't fixed yet
export const ALL_DIVISIONS = [...new Set([...COLLEGE_DIVISIONS, ...HS_DIVISIONS, ...MS_DIVISIONS])];
